/**
 * AlertGroups component module.
 * @module shared/components/AlertGroups
 *
 */
import React from 'react';
import PropTypes from 'prop-types';
import {_openModal} from '../../../shared/reducers/modals';
import {connect} from 'react-redux';
import useSWR from 'swr';
import {Column, DescriptiveText, Icon, LoadingSpinner, Row} from '../../../shared';
import {ColorBox} from '../../../shared/utils/colors';
import qs from 'query-string';
import {isAuthorized} from '../../../shared/reducers/user';
import {withTheme} from 'styled-components/macro';

const AlertGroups = ({cat, target, householdCount, openModal, context, updateContext, theme}) => {
  const alertPriorityColors = {
    High: theme.dark ? '#FFCC03' : '#CF790B',
    Medium: theme.dark ? '#99FA66' : '#79AF30',
    Low: '#9F3D93',
  };
  const {data} = useSWR(cat && cat.type && cat.id && `/${cat.type}/${cat.id}/alerts/groups?${target && !isAuthorized(['ADVISOR'])
    ? qs.stringify({level: target.type, levelID: target.id})
    : ''}`);

  if (!data) {
    return <LoadingSpinner/>;
  }

  return <Column height={'100%'}>
    {!data.length && (!householdCount
      ? <DescriptiveText>You can receive alerts about your clients and their accounts if you create Households.</DescriptiveText>
      : <Row height={'100%'} alignSubRow={'center'}>
        <Icon height={'60px'} width={'60px'} svg={'thumbsUp'}/>
        <DescriptiveText margin={'20px 15px 20px 15px'}>You currently do not have any WealthAlerts.</DescriptiveText>
      </Row>
    )}
    <Column showDividers={true} maxHeight={'100%'}>
      {data.map(a => <Row key={a.title}
                          action={() => openModal({type: 'AlertGroupModal', alertGroup: a, cat, target, updateContext, context})}>
        <Column width={'50px'} layout={{grow: 1}}>
          <DescriptiveText alignment={'left'}>{a.title}</DescriptiveText>
          {householdCount > 1 && <DescriptiveText alignment={'left'}>Households: {a.households}</DescriptiveText>}
        </Column>
        <ColorBox color={alertPriorityColors[a.priority]}/>
      </Row>)}
    </Column>
  </Column>;
};

const mapDispatchToProps = (dispatch) => ({
  openModal: modalToOpen => dispatch(_openModal(modalToOpen)),
});

export default withTheme(connect(null, mapDispatchToProps)(AlertGroups));

AlertGroups.propTypes = {
  /**
   * The base object to gather alerts for
   */
  cat: PropTypes.shape({
    type: PropTypes.oneOf(['households', 'advisors', 'branches', 'firms']).isRequired,
    id: PropTypes.number.isRequired,
  }).isRequired,
  /**
   * Optionally filtered for this. Note this only works when cat.level is households
   */
  target: PropTypes.shape({type: PropTypes.oneOf(['ADVISOR', 'BRANCH', 'FIRM']).isRequired, id: PropTypes.number.isRequired}),
  /**
   * Count of households in the container's current view to display alt no alerts message
   */
  householdCount: PropTypes.number,
  openModal: PropTypes.func,
  /**
   * Used to update context
   */
  updateContext: PropTypes.func.isRequired,
  context: PropTypes.object,
  theme: PropTypes.object,
};
